export default __webpack_public_path__ + "static/media/login-image.f1f8890d.webp";